import React from 'react';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

export const ProgressSection = () => {
  const t = useTranslations();
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);

  return (
    <div className="shadow-xs hidden rounded-xl bg-white p-3 sm:block">
      <p className="text-md font-medium ">{t('savollar')}</p>
      <div className="mb-6 mt-3 flex items-center gap-2">
        <div className="flex-1 rounded-full border-2 border-gray-200 p-0.5">
          <div className="h-2 w-full rounded-full bg-gray-100">
            <div
              className="h-2 rounded-full bg-green-500"
              style={{
                width: `${((currentQuestionIndex + 1) / (questions?.length || 1)) * 100}%`
              }}
            />
          </div>
        </div>
        <div className="text-sm font-medium text-green-500">
          {currentQuestionIndex + 1}/{(questions || []).length}
        </div>
      </div>
    </div>
  );
};
